// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M23.0004 12L12 23.0004L0.999603 12L12 0.999609L23.0004 12ZM7.99921 12L12 16.0008L16.0008 12L12 7.99922L7.99921 12Z" fill="#D9FF66"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M23.0004 12L12 23.0004L0.999603 12L12 0.999609L23.0004 12ZM7.99921 12L12 16.0008L16.0008 12L12 7.99922L7.99921 12Z" style="fill: currentColor"/></svg>`;

export const GreenOrb: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
